import { __awaiter, __decorate, __extends, __generator, __metadata } from "tslib";
import { normalizeResponse } from '../../base/common/normalize';
import { UserVipInfo } from '../../base/common/value-objects/user-vip-info/user-vip-info';
import { Entity } from '../../base/ddd-types/entity';
import { dataFieldNamingHandler, exceptionHandler } from '../../base/decorators';
import { safeParseObject } from '../../base/utils';
import DocMetaRepository from '../repository/doc-meta-repository';
import { DocOwnerInfo } from '../value-object/doc-owner-info';
import { DocPadInfo } from '../value-object/doc-pad-info';
import { DocTitleInfo } from '../value-object/doc-title-info';
import { DOC_STATUS } from '@tencent/ark-service-interface';
import { Emitter } from '@tencent/ark-utils/lib/event';
import { DocCreatorInfo } from '../value-object/doc-creator-info';
import { DocUserAuthInfo } from '../value-object/doc-user-auth-info';
export var UpdateTitleBadCode = {
    RetCode: 12000,
    CgiCode: 12000,
};
/**
 * 文档信息
 */
var DocMetaEntity = /** @class */ (function (_super) {
    __extends(DocMetaEntity, _super);
    function DocMetaEntity(tId) {
        var _this = _super.call(this, tId) || this;
        /**
         * 创建相关信息
         */
        _this.createInfo = new DocCreatorInfo({});
        /**
         * 文档基本信息
         */
        _this.padInfo = new DocPadInfo({});
        /**
         * 文档所有者信息
         */
        _this.ownerInfo = new DocOwnerInfo({});
        /**
         * 文档当前用户基本权限信息
         */
        _this.userAuthInfo = new DocUserAuthInfo({});
        /**
         * 文档标题信息
         */
        _this.titleInfo = new DocTitleInfo({});
        _this.onTitleDidChangeEmitter = new Emitter();
        _this.onhandleNoticeDeletedEmitter = new Emitter();
        _this.onDocStatusChangedEmitter = new Emitter();
        _this.onOfficialAuthInfoChangeEmitter = new Emitter();
        _this.docMetaRepository = new DocMetaRepository();
        _this.onTitleDidChange = _this.onTitleDidChangeEmitter.event;
        _this.onhandleNoticeDeleted = _this.onhandleNoticeDeletedEmitter.event;
        _this.onDocStatusChanged = _this.onDocStatusChangedEmitter.event;
        _this.onOfficialAuthInfoChange = _this.onOfficialAuthInfoChangeEmitter.event;
        return _this;
    }
    DocMetaEntity.prototype.updateTitle = function (title, autoChange) {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, this.docMetaRepository
                            .updateTitle(title, autoChange, (_a = this.padInfo) === null || _a === void 0 ? void 0 : _a.domainId, (_b = this.padInfo) === null || _b === void 0 ? void 0 : _b.padId)];
                    case 1:
                        res = _c.sent();
                        if (parseInt(res.data.retcode, 10) !== UpdateTitleBadCode.RetCode
                            && parseInt(res.data.cgicode, 10) !== UpdateTitleBadCode.CgiCode) {
                            if (this.titleInfo) {
                                this.titleInfo.title = title;
                                this.onTitleDidChangeEmitter.fire({
                                    newTitle: title,
                                });
                            }
                        }
                        return [2 /*return*/, res];
                }
            });
        });
    };
    DocMetaEntity.prototype.handleNoticeDeleted = function () {
        this.padInfo.docStatus = DOC_STATUS.docStatusDelete;
        this.onhandleNoticeDeletedEmitter.fire(undefined);
    };
    DocMetaEntity.prototype.handleNoticeTitleChanged = function (title) {
        this.titleInfo.title = title;
        this.onTitleDidChangeEmitter.fire({ newTitle: title });
    };
    /**
     * 更新认证信息
     */
    DocMetaEntity.prototype.updateOfficialAuthInfo = function (docId) {
        return __awaiter(this, void 0, void 0, function () {
            var res, officialAuthInfo;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.docMetaRepository
                            .updateOfficialAuthInfo(docId, (_a = this.padInfo) === null || _a === void 0 ? void 0 : _a.padType)];
                    case 1:
                        res = _b.sent();
                        officialAuthInfo = res.data.data.clientVars.docInfo.ownerInfo.officialAuthInfo;
                        this.ownerInfo.officialAuthInfo = officialAuthInfo;
                        this.onOfficialAuthInfoChangeEmitter.fire({ officialAuthInfo: officialAuthInfo });
                        return [2 /*return*/, res];
                }
            });
        });
    };
    DocMetaEntity.prototype.changeDocStatus = function (newStatus) {
        this.padInfo.docStatus = newStatus;
        if (newStatus === DOC_STATUS.docStatusDelete) {
            this.onhandleNoticeDeletedEmitter.fire(undefined);
        }
        this.onDocStatusChangedEmitter.fire(undefined);
    };
    /**
     * 获取当前收藏状态
     */
    DocMetaEntity.prototype.fetchCollectedState = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                return [2 /*return*/, this.docMetaRepository.fetchCollectedState((_a = this.padInfo) === null || _a === void 0 ? void 0 : _a.domainId, (_b = this.padInfo) === null || _b === void 0 ? void 0 : _b.padId)];
            });
        });
    };
    /**
     * 设置收藏/取消收藏
     */
    DocMetaEntity.prototype.changeCollectedState = function (collect) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                return [2 /*return*/, this.docMetaRepository.changeCollectedState((_a = this.padInfo) === null || _a === void 0 ? void 0 : _a.domainId, (_b = this.padInfo) === null || _b === void 0 ? void 0 : _b.padId, collect)];
            });
        });
    };
    DocMetaEntity.prototype.fetchDocMetaInfoData = function (docId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.docMetaRepository.fetchDocMetaInfoData(docId)];
            });
        });
    };
    /**
     * 获取 drive 文件信息
     */
    DocMetaEntity.prototype.fetchFileInfo = function (docId, addRecent) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.docMetaRepository.fetchFileInfo(docId, addRecent)];
            });
        });
    };
    DocMetaEntity.prototype.getOwnerVipInfo = function (padId_1) {
        return __awaiter(this, arguments, void 0, function (padId, getAll) {
            var responseVipInfo, normalizedVipInfo, _a, vipLevel, vipInfoString, vipInfo;
            if (getAll === void 0) { getAll = false; }
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.docMetaRepository.getOwnerVipInfo(padId, getAll)];
                    case 1:
                        responseVipInfo = _b.sent();
                        normalizedVipInfo = normalizeResponse(responseVipInfo, true);
                        if (normalizedVipInfo.resData) {
                            _a = normalizedVipInfo.resData.data.result || {}, vipLevel = _a.vipLevel, vipInfoString = _a.vipInfo;
                            vipInfo = safeParseObject(vipInfoString, {});
                            this.ownerInfo.vipLevel = vipLevel;
                            this.ownerInfo.vipInfo = new UserVipInfo(vipInfo);
                        }
                        return [2 /*return*/, normalizedVipInfo];
                }
            });
        });
    };
    __decorate([
        exceptionHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String, Boolean]),
        __metadata("design:returntype", Promise)
    ], DocMetaEntity.prototype, "updateTitle", null);
    __decorate([
        exceptionHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", Promise)
    ], DocMetaEntity.prototype, "updateOfficialAuthInfo", null);
    __decorate([
        exceptionHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], DocMetaEntity.prototype, "fetchCollectedState", null);
    __decorate([
        exceptionHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", Promise)
    ], DocMetaEntity.prototype, "changeCollectedState", null);
    __decorate([
        dataFieldNamingHandler(),
        exceptionHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", Promise)
    ], DocMetaEntity.prototype, "fetchDocMetaInfoData", null);
    __decorate([
        exceptionHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String, Boolean]),
        __metadata("design:returntype", Promise)
    ], DocMetaEntity.prototype, "fetchFileInfo", null);
    return DocMetaEntity;
}(Entity));
export default DocMetaEntity;
